export default {
      id: "logo-small-blue-usage",
      viewBox: "0 0 41 41",
      url: "/" + "sprite.svg#logo-small-blue",
      toString: function () {
        return this.url;
      }
    }